export const routeMappings = {
  // English to Arabic mappings
  '/en/': '/',

  // Arabic to English mappings
  '/': '/en/',
};
